<template>
  <div id="content" class="dlnkmediatheque_new_books container">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <!-- Submit Project Section -->
    <div class="container space-1 space-bottom-2">
      <div class="w-lg-75 mx-lg-auto">
        <!-- Title -->
        <div class="text-center mb-4">
          <h1 v-if="typeof book.title !== 'undefined'">{{ book.title }}</h1>
          <h1 v-else>Ajouter un nouveau livre</h1>
        </div>
        <!-- End Title -->

        <!-- Card -->
        <form method="post"
              @submit.prevent="submit_form"
              id="book_form"
              enctype="multipart/form-data"
              class="needs-validation" novalidate>

          <div class="card card-bordered shadow-none">
            <div class="card-body">

              <!-- Form Group -->
              <div class="row form-group">
                <label for="title" class="col-sm-3 col-form-label input-label">Titre du livre :</label>

                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" name="title" id="title" v-model="book.title"
                         required
                         minlength="3"
                         maxlength="255">
                  <div class="invalid-feedback">
                    Le titre du livre doit contenir au moins 3 caractères.
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="isbn" class="col-sm-3 col-form-label input-label">ISBN :</label>

                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" name="isbn" id="isbn" v-model="book.isbn"
                         maxlength="20">
                  <div class="invalid-feedback">
                    Le code ISBN est incorrect.
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="editor_id" class="col-sm-3 col-form-label input-label">Editeur</label>

                <div class="col-sm-9">
                  <select id="editor_id" name="editor_id" class="custom-select custom-select-sm" required v-model="book.editor_id">
                    <option value="">-- Veuillez sélectionner un editeur --</option>
                    <option
                        v-for="editor in editors"
                        :key="editor.id"
                        :value="editor.id">
                      {{ editor.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner un editeur
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="place_id" class="col-sm-3 col-form-label input-label">Lieu stockage</label>

                <div class="col-sm-9">
                  <select id="place_id" name="place_id" class="custom-select custom-select-sm" required v-model="book.place_id">
                    <option value="">-- Veuillez sélectionner une antenne --</option>
                    <option
                        v-for="place in places"
                        :key="place.id"
                        :value="place.id">{{ place.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner une antenne
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="genre_id" class="col-sm-3 col-form-label input-label">Genre</label>

                <div class="col-sm-9">
                  <select id="genre_id" name="genre_id" class="custom-select custom-select-sm" required v-model="book.genre_id">
                    <option value="">-- Veuillez sélectionner un genre --</option>
                    <option
                        v-for="genre in genres"
                        :key="genre.id"
                        :value="genre.id">{{ genre.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner un genre
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="age_range_id" class="col-sm-3 col-form-label input-label">Tranche d'âge</label>

                <div class="col-sm-9">
                  <select id="age_range_id" name="age_range_id" class="custom-select custom-select-sm" required v-model="book.age_range_id">
                    <option value="">-- Veuillez sélectionner une tranche d'age --</option>
                    <option
                        v-for="age_range in age_ranges"
                        :key="age_range.id"
                        :value="age_range.id">{{ age_range.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner une tranche d'age
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <div class="row form-group">

                <label for="picture" class="col-sm-3 col-form-label input-label mt-4">Photo</label>

                <div class="col-sm-4">
                  <img class="img-fluid w-100 rounded-lg"
                       :src="'/modules/dlnkmediatheque/actions/get_file.php?uuid=' + book.uuid" alt="Book image">
                </div>

                <div class="col-sm-5">
                  <input type="file"
                         id="picture" name="picture"
                         accept="image/png, image/jpeg">

                  <div class="invalid-feedback">
                    Veuillez selectionner une image jpeg ou png.
                  </div>
                </div>

              </div>

              <!-- Form Group -->
              <div class="row form-group">
                <label for="synopsis" class="col-sm-3 col-form-label input-label mt-4">Synopsis</label>

                <div class="col-sm-9">

                  <ckeditor :editor="editor" v-model="book.synopsis"
                            :config="editor_config" id="synopsis" name="synopsis">

                  </ckeditor>

                </div>
              </div>
              <!-- End Form Group -->

            </div>
            <!-- End Card -->
            <div class="text-center mt-1 mb-4">
              <button type="submit" class="btn btn-primary px-lg-5">Enregistrer</button>
            </div>
          </div>
        </form>
      </div>
      <!-- End Submit Project Section -->
    </div>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  props: {
    book_id: Number,
  },

  data: function () {
    return {
      book: Object(),
      age_ranges: Array(),
      editors: Array(),
      genres: Array(),
      places: Array(),
      message: "",
      message_type: "",
      method: "",
      editor: ClassicEditor,
      synopsis: "",
      editor_config: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'}
          ]
        }
      },
    }
  },

  mounted() {
    this.method = 'post'
    this.get_data()
  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    clean_field: function () {
      document.getElementById("book_form").reset();
      document.getElementById("book_form").classList.remove("was-validated");
      this.synopsis = "";
    },

    get_data: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/books.php';

      axios.get(url)
          .then(function (response) {
            _this.age_ranges = response.data.age_ranges
            _this.editors = response.data.editors
            _this.genres = response.data.genres
            _this.places = response.data.places
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });


      if (_this.book_id) {
        let url = '/modules/dlnkmediatheque/actions/book.php?book_id=' + _this.book_id;

        axios.get(url)
            .then(function (response) {
              _this.book = response.data.book
              _this.method = 'patch'
            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              // always executed
            });

      }

    },

    submit_form: function () {
      const _this = this;
      const url = '/modules/dlnkmediatheque/actions/book.php';

      const form_element = document.getElementById("book_form");
      const form_data = new FormData(form_element);
      form_data.append('synopsis', _this.book.synopsis)
      form_data.append('method', _this.method)

      if (_this.method === 'patch') {
        form_data.append('book_id', _this.book_id)
      }

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data'}
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              if (_this.method === 'post') {
                _this.message = "Livre ajouté.";
                _this.clean_field();
              } else if (_this.method === 'patch') {
                _this.message = "Livre modifié."
                _this.get_data()
              }
              _this.message_type = 'alert-success'

            } else {
              _this.message = response.data.errors;
              _this.message_type = 'alert-danger'
            }
          })
          .catch(function (response) {
            //handle error
          });
    },
  }
}

</script>
